// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2fcMN","title":"BackImages_title__2cCmK","images":"BackImages_images__2gaw1"};